import React from 'react';
import {Route, Routes } from 'react-router-dom';
import Home from './pages/home';
import Tos from './pages/tos';
import Policy from './pages/policy';
import AuthCallback from './pages/auth-callback';
import YahooCallback from './pages/yahoo-callback';
import Profile from './pages/profile';
import GuildConfig from './pages/guild-config';

function AppRoutes() {
  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/tos" element={<Tos />} />
        <Route path="/auth/discord/callback" element={<AuthCallback />} />
        <Route path="/auth/yahoo/callback" element={<YahooCallback />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/config/:guildId" element={<GuildConfig />} />
      </Routes>
  );
}

export default AppRoutes;

